import styled, {css} from 'styled-components';
import React from 'react';
import {basicColor, radius} from '../../../../styles/template';

interface PropsType {
    children: React.ReactNode
    onClick?: any
    large?: boolean
    primary?: boolean
    disabled?: boolean
    transparent?: boolean
    className?: string
    type?: any
    success?: boolean
    href?: string
    faint?: boolean
}

const Wrap = styled.button<PropsType>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${radius.normal};
    height: 5rem;
    width: 5rem;
    background: ${basicColor.transparent};
    transition: all 0.2s ease-out;

    &:active {
        transform: translateY(0.5rem);
    }
    
    & .colorFill {
        fill: ${basicColor.white};
    }
    
    & .colorStroke {
        stroke: ${basicColor.white};
    }

    &:hover {
      opacity: 0.8;
    }

    ${({ large }) => large && css`
        height: 6rem;
        width: 6rem;
    `}

    ${({ primary }) => primary && css`
        background: ${basicColor.primary};
      
        &:hover {
            background: ${basicColor.primaryLight};
            opacity: 1;
        }
    `}

    ${({ faint, theme }) => faint && css`
        color:  ${basicColor.primary};
        background-color:  ${basicColor.primaryTransparent};

        & .colorFill {
            fill:  ${basicColor.primary};
        }

        & .colorStroke {
            stroke:  ${basicColor.primary};
        }
    `}

    ${({ success }) => success && css`
        background: ${basicColor.secondary};
      
        &:hover {
            background: ${basicColor.secondaryDark};
            opacity: 1;
        }
    `}



    ${({ transparent, theme }) => transparent && css`
        background: transparent;
      
        & .colorFill {
            fill: ${theme.color.Text};
        }
        
        & .colorStroke {
            stroke: ${theme.color.Text};
        }
      
        &:hover {
            background: transparent;
        }
    `}


    ${({ theme, disabled }) => disabled && css`
        &:active {
          transform: none;
        }

        &:hover {
            opacity: 1;
        }
      
        & .colorFill {
            fill: ${theme.color.MidtoneItem};
        }
        
        & .colorStroke {
            stroke: ${theme.color.MidtoneItem};
        }
        
        &:hover {
            & .colorFill {
                fill: ${theme.color.MidtoneItem} !important;
            }
            & .colorStroke {
                stroke: ${theme.color.MidtoneItem} !important;
            }
        }

        &:before, &:after, &:hover:before, &:hover:after {
            transition: none;
            transform: none;
            opacity: 1;
        }
    `}  
`

const IconButton: React.FC<PropsType> = props => {
    const { children, href, ...restProps } = props;

    if (href) {
        return (
            <Wrap as="a" href={href} {...restProps}>{children}</Wrap>
        );
    }

    return <Wrap {...restProps}>{children}</Wrap>
}

export default IconButton;